import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import emailjs from "@emailjs/browser";
import LoadingPopup from "../helpers/loading_component.js";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import { secretKey } from "../.././data";
import Docxtemplater from "docxtemplater";
import PizZip from "pizzip";
import PizZipUtils from "pizzip/utils/index.js";
import { saveAs } from "file-saver";
import { isArray } from "util";
import EditPelnSub from "./editPelnSub.js";

const MySwal = withReactContent(Swal2);

const EditLawsuitData = (props) => {
  const [showEditPelnSub, setShowEditPelnSub] = useState(false);
  const [loading, setLoading] = useState(false);
  const [deliveryDate, setDeliveryDate] = useState(
    props.clientsData.dateDeliverWezw ? props.clientsData.dateDeliverWezw : ""
  );
  const [sendDate, setSendDate] = useState(
    props.clientsData.sendDate ? props.clientsData.sendDate : ""
  );
  const [dateWym, setDateWym] = useState(
    props.clientsData.dateWym ? props.clientsData.dateWym : ""
  );
  const [realCreditValue, setRealCreditValue] = useState(
    props.clientsData.realCreditValue
      ? +props.clientsData.realCreditValue.replaceAll(",", ".") > 0
        ? props.clientsData.realCreditValue
        : ""
      : ""
  );
  const [payTime, setPayTime] = useState(
    +props.clientsData.wezwPayTime
      .toString()
      .replaceAll(" dni", "")
      .replaceAll(" dzień", "")
  );

  const getData = async () => {
    return;
  };

  useEffect(() => {
    getData();
  }, []);

  const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, " ");
  };

  const checkDigit = (e) => {
    if (!/^\d*\,?\d*$/.test(e.key)) {
      e.preventDefault();
    }
  };

  const validate = () => {
    return true;
    if (+realCreditValue <= 0) {
      return false;
    }
    if (deliveryDate.length === 0) {
      return false;
    }
    if (dateWym.length === 0) {
      return false;
    }
    return true;
  };

  const addDays = (date) => {
    var dateN = new Date(date);
    var retDate = new Date(dateN.setDate(dateN.getDate() + payTime + 1));

    return (
      retDate.getFullYear() +
      "-" +
      (retDate.getMonth() + 1 < 10
        ? "0" + (retDate.getMonth() + 1)
        : retDate.getMonth() + 1) +
      "-" +
      (retDate.getDate() < 10 ? "0" + retDate.getDate() : retDate.getDate())
    );
  };

  const generateDocument = async () => {
    if (!validate()) {
      MySwal.fire({
        icon: "error",
        title: "Uzupełnij",
        text: "wymagane pola formularza",
      }).then(async (result) => {});
      return;
    }

    var bodyX = {
      clientId: props.clientsData.id,
      dateDeliveryWezw: deliveryDate,
      dateWym: dateWym,
      realCreditValue: realCreditValue,
      sendDate: sendDate,
    };

    fetch("https://apidevkppp.ftpeople.pl/updateLawsuitData", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(bodyX),
    })
      .then((response) => response.text())
      .then((responseJson) => {
        MySwal.fire({
          icon: "success",
          title: "Edytowano",
          text: "informacje do pozwu",
        }).then(async (result) => {
          props.close();
        });
      });
  };

  const handleDeliveryChange = (e) => {
    setDeliveryDate(e.target.value);
    setDateWym(addDays(e.target.value));
  };

  const handleSendDateChange = (e) => {
    setSendDate(e.target.value);
  };

  return (
    <div
      style={{ width: "50vw", top: "25vh" }}
      className="mainContainerAddClientContact"
    >
      {loading ? (
        <LoadingPopup />
      ) : (
        <>
          <div className="closeBox">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>

          <div id="addPaymentIC" className="inputContainer">
            <>
              <div id="addPaymentIC" className="inputContainer">
                <div className="inputBox">
                  <div style={{ minWidth: "49%" }} className="inputCol_2">
                    <label>
                      Rzeczywista kwota wypłaconego kredytu
                      <span className="requiredStar">*</span>
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={realCreditValue}
                      onChange={(e) => {
                        setRealCreditValue(e.target.value);
                      }}
                      onKeyPress={checkDigit}
                      onFocus={() => {
                        setRealCreditValue("");
                      }}
                    />
                  </div>
                  <div style={{ minWidth: "49%" }} className="inputCol_2">
                    <label>
                      Potwierdzenie nadania wezwania
                      <span className="requiredStar">*</span>
                    </label>
                    <input
                      type="date"
                      id="name"
                      name="name"
                      value={sendDate}
                      onChange={handleSendDateChange}
                    />
                  </div>
                </div>
                <div className="inputBox">
                  <div style={{ minWidth: "49%" }} className="inputCol_2">
                    <label>
                      Data doręczenia wezwania
                      <span className="requiredStar">*</span>
                    </label>
                    <input
                      type="date"
                      id="name"
                      name="name"
                      value={deliveryDate}
                      onChange={handleDeliveryChange}
                    />
                  </div>
                  <div style={{ minWidth: "49%" }} className="inputCol_2">
                    <label>
                      Data wymagalności
                      <span className="requiredStar">*</span>
                    </label>
                    <input
                      type="date"
                      id="name"
                      name="name"
                      value={dateWym}
                      onChange={(e) => {
                        setDateWym(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>
            </>

            <div className="saveBoxAP">
              <button className="paymentMenuButton" onClick={generateDocument}>
                ZAPISZ
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default EditLawsuitData;
